import { GetterTree } from "vuex";
import { WhiteboardState, AlterContentMediaState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<WhiteboardState, any> = {
  //getWhiteboardMediaState
  [defineVuexName(MODULES.WHITE_BOARD.GETTERS.GET_WHITE_BOARD_MEDIA_STATE)](state: WhiteboardState): AlterContentMediaState | null {
    return state.mediaState;
  },
  //getShouldFetchMediaState
  [defineVuexName(MODULES.WHITE_BOARD.GETTERS.GET_SHOULD_FETCH_MEDIA_STATE)](state: WhiteboardState): boolean {
    return state.shouldFetchMediaState;
  },
};

export default getters;
